import React, { Component } from "react";
import containerImage from '../styles/images/container_icon.png';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from 'prop-types';
import moment from 'moment';
import subDays from "date-fns/subDays";

export default class Container extends Component {
    constructor(props) {
        super(props);
     
           
        this.state = {
            showing: false,
            startDate: new Date(),
            showApply: false,
            prePullCheck: false,
            dropOffCheck: false,
            isPMcheck: this.props.isPMCheck,
            isAMcheck: this.props.isPMCheck,
            isStrictCheck: false,
            StrictTime: '',
            AppointmentDate: '',
            orderId: this.props.orderId,
            includeDates: this.props.includeDatesi,
            totalcapacity: this.totalcapacity,
            totalContainerCount: this.props.totalContainerCount,
            capacityShowApply: this.props.capacityShowApply,
            appointmentTime : ''
            
        };
    }

    handleApply() {
        console.log('this.props.containerID', this.props.containerID)
        this.props.handleApply(this.props.containerID);
    }

    timeChange(type, date) {
        if (this.state.isStrictCheck) {
            this.setState({
                AppointmentDate: moment(date).format('L'),
                StrictTime: moment(date).format('LT'),
                startDate : date,
            })
        }
        if (type && !this.state.isStrictCheck) {
            this.setState({
                AppointmentDate: moment(date).format('L'),
                startDate: date,
                showApply: this.props.capacityShowApply
            });
        }
        let asd = this;
        if (date != "") {
            let ct = this.props.totalCapacity;
            let applyButtonCt = ct.filter(capacity => new Date(capacity.day).toDateString() == new Date(date).toDateString());
            if (this.props.totalContainerCount > applyButtonCt[0].capacity) {
                
                this.setState({ 
                    showApply: false, 
                });
            }

            console.log("app", applyButtonCt);
        }

        setTimeout(function () {
            asd.handleChange(type);
        }, 300)
    }
    handleChange(type) {
        let obj = {
            containerID: 0,
            prePull: this.state.prePullCheck,
            dropOff: this.state.dropOffCheck,
            isPM: this.state.isPMcheck,
            isAM: this.state.isAMcheck,
            isStrict: this.state.isStrictCheck,
            StrictTime: this.state.StrictTime,
            AppointmentDate: this.state.AppointmentDate,
            DeliveryOrderId: this.state.orderId,
            includeDates: this.includeDates,
            capacityShowApply : this.props.capacityShowApply
        }

        obj.containerID = parseInt(this.props.containerID);
       
        
         
        if (type === 'prePull') {
            this.setState({
                prePullCheck: !this.state.prePullCheck
            }, () => { obj.prePull = this.state.prePullCheck });
        }
        if (type === 'dropOff') {
            this.setState({
                dropOffCheck: !this.state.dropOffCheck
            }, () => { obj.dropOff = this.state.dropOffCheck });
        }
        if (type === 'isPM') {
            this.setState({
                isPMcheck: true,
                isAMcheck: false,
                isStrictCheck: false
            }, () => {
                obj.isPM = true;
                obj.isAM = false;
                obj.isStrict = false;
            });
        }
        if (type === 'isAM') {
            this.setState({
                isPMcheck: false,
                isAMcheck: true,
                isStrictCheck: false
            }, () => {
                obj.isPM = false;
                obj.isAM = true;
                obj.isStrict = false;
            });
        }
        if (type === 'isStrict') {
            this.setState({
                isPMcheck: false,
                isAMcheck: false,
                isStrictCheck: true
            }, () => {
                obj.isPM = false;
                obj.isAM = false;
                obj.isStrict = true;
            });
        }
        this.props.handleChange(obj);
    }

     
    render() {

        const isActiveDays = date => {   
            let daysOfYear = []; 
            let cutoff = new  Date(this.props.cutOffDate);
            let av_date = new  Date(this.props.availableDatee);
            let ct = this.props.totalCapacity;
           
            for (var d = av_date; d <= cutoff; d.setDate(d.getDate()+ 1)) {
                if (ct != undefined) {
                    let activeCt = ct.filter(capacity => new Date(capacity.day).toDateString() == d.toDateString());

                    if (activeCt.length > 0 && activeCt[0].capacity > 1) { 
                        daysOfYear.push(new Date(d)); 
                    }  
                    
                }  
            } 
            let isActiveDate = (daysOfYear.find(s => s.toDateString() == date.toDateString()) ? true : false) 

            return isActiveDate;
        };
 


        return (
            <div className="col-lg-6 col-md-12 col-sm-12 mb-4" key={this.props.keyVal}>
                <div className="card">
                    <div className="card-header">
                        <div className="row" style={{ paddingLeft: 15 }}>
                            <div className="col-lg-6 col-xs-12">
                                <strong>Container # - {this.props.containerID}</strong>
                            </div>
                            <div className="col-lg-6 col-xs-12" style={{ textAlign: "right" }}>
                                <span style={{ color: this.props.appointmentDate === "" ? "red" : "green", fontWeight: "bold" }}>{this.props.appointmentDate !== "" ? "Scheduled To: " + this.props.appointmentDate : "Not Scheduled"}</span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row" style={{ paddingRight: 15, paddingLeft: 15, marginTop: -10, marginBottom: 10 }}>
                            <div className="col-sm-5">
                                <div className="row p-2">
                                    Avaliable Date: <strong>{this.props.availableDatee}</strong>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-3" style={{ textAlign: "center", paddingTop: 10 }}>
                                        <img src={containerImage} className="imgSize" alt={""} />
                                    </div>
                                    <div className="col-md-9">
                                        <strong>{this.props.containerNo}</strong><br />
                                        <label>Container Schedule Date</label><br />
                                        <div className="row" style={{ marginLeft: 0 }}>
                                            <DatePicker
                                                dateFormat="MM/dd/yyyy"
                                                onChange={(date) => this.timeChange(true, date)}  
                                                selected={this.state.AppointmentDate !== "" ? new Date(this.state.AppointmentDate) : new Date(this.props.appointmentDate)  }
                                                filterDate={isActiveDays}
                                            /> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="row p-2 justify-content-center mb-4">
                                    ERD: <strong>{this.props.erd}</strong>
                                </div>
                                <div className="row p-2 justify-content-center">
                                    <div className="custom-control custom-checkbox mb-3">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id={'isPrePull_' + this.props.containerID}
                                            onChange={() => this.handleChange('prePull')} 
                                            defaultChecked={this.props.prePullCheck}

                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor={'isPrePull_' + this.props.containerID}
                                        >
                                            Pre-Pull
                                                 </label>
                                    </div>
                                </div>
                                <div className="row p-2 justify-content-center">
                                    <div className="custom-control custom-checkbox mb-3" style={{ marginLeft: 5 }}>
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id={'isDropOff_' + this.props.containerID}
                                            onChange={() => this.handleChange('dropOff')}
                                            defaultChecked={this.props.dropOffCheck}

                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor={'isDropOff_' + this.props.containerID}
                                        >
                                            Drop-Off
                                                 </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="row p-2 justify-content-end">
                                    Cut Off Day:<strong>{this.props.cutOffDate}</strong>
                                </div>
                                <div className="row mt-4 justify-content-end">
                                    <div className="custom-control custom-radio">
                                        <input
                                            type="radio"
                                            className="custom-control-input"
                                            id={'isAM_' + this.props.containerID}
                                            name={'radio_' + this.props.containerID}
                                            onClick={() => this.setState({ showing: false })}
                                            onChange={() => this.handleChange('isAM')}
                                            defaultChecked={this.props.isAMCheck}
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor={'isAM_' + this.props.containerID}
                                        >
                                            A.M
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio">
                                        <input
                                            type="radio"
                                            className="custom-control-input"
                                            id={'isPM_' + this.props.containerID}
                                            name={'radio_' + this.props.containerID}
                                            onClick={() => this.setState({ showing: false })}
                                            onChange={() => this.handleChange('isPM')} 
                                            defaultChecked={this.props.isPMCheck}
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor={'isPM_' + this.props.containerID}
                                        >
                                            P.M
                                                 </label>
                                    </div>
                                    <div className="custom-control custom-radio mb-3">
                                        <input
                                            type="radio"
                                            className="custom-control-input"
                                            id={'isStrictTime_' + this.props.containerID}
                                            name={'radio_' + this.props.containerID}
                                            onClick={() => this.setState({ showing: true })}
                                            onChange={() => this.handleChange('isStrict')}
                                            defaultChecked={this.props.isStrictCheck}
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor={'isStrictTime_' + this.props.containerID}
                                        >
                                            Strict Time
                                                    </label>
                                    </div>
                                </div>
                                <div className="row p-2" style={{ display: this.state.showing === true ? 'block' : 'none', textAlign: "right" }}>
                                    <DatePicker
                                        selected={this.state.startDate}
                                        onChange={(date) => this.timeChange(true, date)}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        dateFormat="h:mm aa"
                                        timeCaption="Time"
                                        id={'strictTimePicker_' + this.props.containerID}
                                       
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-end" style={{ paddingRight: 15 }}>
                            <button className="btn btn-orange btn-sm" id={'applyButton_' + this.props.containerID} style={{ display: this.state.showApply ? 'block' : 'none', marginTop: 2 }} onClick={() => this.handleApply()}>Apply to All</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Container.propTypes = {
    containerID: PropTypes.string,
    appointmentDate: PropTypes.string,
    availableDate: PropTypes.string,
    containerNo: PropTypes.string,
    erd: PropTypes.string,
    cutOffDate: PropTypes.string,
    handleChange: PropTypes.func,
    includeDates: PropTypes.any,
    totalcapacity: PropTypes.any,
    totalContainerCount: PropTypes.number,
    capacityShowApply: PropTypes.bool
}




// WEBPACK FOOTER //
// ./src/components/Container.js